import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { SMS_CODE_MODAL } from "../../../../../../dependencies/getContent/constants";
import { produce } from "../../../../../../../libs/immer";
import { templateParser } from "../../../../../../../utils/strings";
import { formatValue } from "../../../PaymentSelection/components/PaymentDetailsSection/InputSection/components/PhoneInput/utils";
import { submitSmsCodeUseCase } from "./submit.case";
export var getMapStateToSMSConfirmationPopupProps = function getMapStateToSMSConfirmationPopupProps(_ref) {
  var getContent = _ref.getContent,
    submitPayment = _ref.submitPayment,
    sendSmsCode = _ref.sendSmsCode,
    getUserAccountInfo = _ref.getUserAccountInfo;
  return function (getState, setState) {
    var _state$scenario;
    var state = getState();
    var _getContent = getContent(),
      _getContent$smsPopup = _getContent.smsPopup,
      title = _getContent$smsPopup.title,
      buttonProps = _getContent$smsPopup.buttonProps,
      subtitle = _getContent$smsPopup.subtitle,
      length = _getContent$smsPopup.length;
    if (((_state$scenario = state.scenario) === null || _state$scenario === void 0 ? void 0 : _state$scenario.type) !== SMS_CODE_MODAL) return undefined;
    return {
      backButtonProps: {
        children: '',
        onClick: function onClick() {
          setState(produce(function (draft) {
            draft.scenario = undefined;
          }));
        }
      },
      titleProps: {
        subTitle: templateParser(subtitle, {
          phoneNumber: formatValue(getUserAccountInfo().accountNumber)
        }),
        title: title
      },
      buttonProps: _objectSpread(_objectSpread({}, buttonProps), {}, {
        onClick: function onClick() {
          sendSmsCode(getState, setState).catch(console.error);
        }
      }),
      codeInputProps: {
        onChange: function onChange(input) {
          var nextState = produce(state, function (draft) {
            var _draft$scenario;
            if (((_draft$scenario = draft.scenario) === null || _draft$scenario === void 0 ? void 0 : _draft$scenario.type) !== SMS_CODE_MODAL) return;
            draft.scenario.codeInput.value = input;
          });
          setState(function () {
            return nextState;
          });
          if (input.length >= length) {
            submitSmsCodeUseCase({
              submitPayment: submitPayment
            })(function () {
              return nextState;
            }, setState).catch(console.error);
          }
        },
        onEnter: function onEnter() {
          submitSmsCodeUseCase({
            submitPayment: submitPayment
          })(getState, setState).catch(console.error);
        },
        value: state.scenario.codeInput.value,
        codeLength: length,
        error: !!state.scenario.codeInput.errorMessage
      },
      isLoading: state.scenario.isLoading
    };
  };
};